import { IconButton, Stack, Tooltip } from '@mui/material';
import { Controller } from 'react-hook-form';
import { DeleteOutline } from '@mui/icons-material';
import { Column } from 'components/shared/TableListing/types';
import { InputField, ColorPickerField } from 'components/form';
import { green, grey, orange, red, yellow } from '@mui/material/colors';
import { TierEntity, TierTableContext } from './types';

export const newTier = {
  name: 'New',
  color: 'black',
  criteria: null,
  description: '',
};

export const initialTableData: TierEntity[] = [
  { color: green['400'], name: 'Prime' },
  { color: yellow['400'], name: 'Near-Prime' },
  { color: orange['400'], name: 'Mid-Tier' },
  { color: red['400'], name: 'Subprime' },
  { color: grey['400'], name: 'Not qualified' },
].map(tier => ({ ...tier, description: '', isActive: false, criteria: null }));

export const initialColumns: Column<TierEntity, TierTableContext>[] = [
  {
    width: '4.5rem',
    header: 'Actions',
    renderKey: 'actions',
    renderCell: ({ context: { handleRemoveRow }, rowIndex }) => (
      <Tooltip title="Remove Tier">
        <IconButton
          onClick={() => {
            handleRemoveRow(rowIndex);
          }}
        >
          <DeleteOutline color="error" />
        </IconButton>
      </Tooltip>
    ),
  },
  {
    renderKey: 'name',
    header: 'Internal Tier Name',
    renderCell: ({ context: { form }, rowIndex }) => (
      <Stack direction="row" gap="1rem" width="100%" alignItems="center">
        <Controller
          control={form.control}
          name={`bodyFields.${rowIndex}.color`}
          render={({ field: { value, onChange } }) => (
            <ColorPickerField initialColor={value ?? initialTableData[rowIndex].color} onColorChanged={onChange} />
          )}
        />

        <InputField control={form.control} inputProps={{ variant: 'outlined' }} name={`bodyFields.${rowIndex}.name`} />
      </Stack>
    ),
  },
  {
    renderKey: 'description',
    header: 'Description',
    renderCell: ({ context: { form }, rowIndex }) => (
      <InputField
        control={form.control}
        name={`bodyFields.${rowIndex}.description`}
        inputProps={{ variant: 'outlined', placeholder: 'Description' }}
      />
    ),
  },
];
